import React from "react";
import { Link } from "react-router-dom";
import { Calendar, RefreshCw, ShieldCheck, ArrowRight } from "lucide-react";
import Layout from "../components/Layout";

export default function Home() {
  return (
    <Layout>
      
        <h1 className="text-3xl sm:text-4xl tracking-tight font-bold text-slate-900 mt-3" style={{ fontFamily: "Manrope" }}>
          Cuidar da sua saúde ficou
          <br />
          <span className="text-[#00357C]">simples e rápido.</span>
        </h1>
        <p className="text-slate-600 mt-3 leading-relaxed">
          Marque uma nova consulta ou remarque um horário ja existente em poucos toques. Tudo direto pelo seu celular.
        </p>

      <div className="mt-8 space-y-4 fade-up-stagger">
        <Link
          to="/agendar"
          data-testid="home-novo-agendamento"
          className="block bg-white border border-slate-200 rounded-2xl p-5 hover:-translate-y-0.5 hover:shadow-md transition-all group"
        >
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-xl bg-[#00357C] text-white flex items-center justify-center shrink-0">
              <Calendar size={22} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-slate-900" style={{ fontFamily: "Manrope" }}>
                Marcar nova consulta
              </div>
              <p className="text-sm text-slate-600 mt-1 leading-relaxed">
                Escolha especialidade, profissional e horário disponível.
              </p>
            </div>
            <ArrowRight size={20} className="text-slate-400 group-hover:text-[#00357C] transition" />
          </div>
        </Link>

        <div
          data-testid="home-remarcacao-info"
          className="block bg-[#EAF5F6] border border-[#D7EBED] rounded-2xl p-5"
        >
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-xl bg-[#5CACB0] text-white flex items-center justify-center shrink-0">
              <RefreshCw size={22} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-slate-900" style={{ fontFamily: "Manrope" }}>
                Remarcar consulta
              </div>
              <p className="text-sm text-slate-700 mt-1 leading-relaxed">
                A remarcação é feita através do link recebido no seu WhatsApp de confirmação.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-10 text-center text-xs text-slate-400">
        Seus dados são tratados com segurança conforme a LGPD.
      </div>
    </Layout>
  );
}
